/* eslint-disable react/boolean-prop-naming */

import React from 'react';
import PropTypes from 'prop-types';
import MultiItemSelectOptions from './MultiItemSelectOptions';
import { MultiItemSelectContext } from './MultiItemSelectContext';

function MultiItemSelect(props) {
  const {
    options,
    setOptions,
    leftMenuTitle,
    rightMenuTitle,
    allowItemOrdering,
    allowEmptyRightOptions,
    onLeftSelect,
    onRightSelect,
    onLeftItemMove,
    onRightItemMove,
    theme,
    onChange,
    rightMenuNumbering = false,
    strategy,
    setSelectedItem,
    showError,
    onBlur, // added onBlur to use this field inside react form
    onFocus, // added onFocus to use this field inside react form
  } = props;

  const contextValue = {
    options,
    setOptions,
    leftMenuTitle,
    rightMenuTitle,
    rightMenuNumbering,
    strategy,
    allowItemOrdering,
    allowEmptyRightOptions,
    onLeftSelect,
    onRightSelect,
    onLeftItemMove,
    onRightItemMove,
    theme,
    onChange,
    setSelectedItem,
    showError,
    onBlur,
    onFocus,
  };

  return (
    <MultiItemSelectContext.Provider value={contextValue}>
      <MultiItemSelectOptions />
    </MultiItemSelectContext.Provider>
  );
}

MultiItemSelect.propTypes = {
  options: PropTypes.arrayOf({}),
  setOptions: PropTypes.func,
  leftMenuTitle: PropTypes.string,
  rightMenuTitle: PropTypes.string,
  // eslint-disable-next-line react/boolean-prop-naming
  allowItemOrdering: PropTypes.bool,
  allowEmptyRightOptions: PropTypes.bool,
  onLeftSelect: PropTypes.func,
  onRightSelect: PropTypes.func,
  onLeftItemMove: PropTypes.func,
  onRightItemMove: PropTypes.func,
  theme: PropTypes.shape({}),
  onChange: PropTypes.func,
  rightMenuNumbering: PropTypes.bool,
  strategy: PropTypes.string,
  setSelectedItem: PropTypes.func,
  showError: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

MultiItemSelect.defaultProps = {
  /** options for multi select  */
  options: undefined,
  /** Left Menu Title  */
  leftMenuTitle: '',
  /** Right Menu Title  */
  rightMenuTitle: '',
  allowItemOrdering: false,
  /** Left Item Select  */
  onLeftSelect: () => {},
  /** Right Item Select  */
  onRightSelect: () => {},
  /** Left Item Move  */
  onLeftItemMove: () => {},
  /** Right Item Move  */
  onRightItemMove: () => {},
  showError: () => {},
};

export default MultiItemSelect;
